module.exports = __webpack_public_path__ + "img/kong-apiops.935c7299.svg";